import { render, staticRenderFns } from "./websiteConfig.vue?vue&type=template&id=3596034c&scoped=true&"
import script from "./websiteConfig.vue?vue&type=script&lang=js&"
export * from "./websiteConfig.vue?vue&type=script&lang=js&"
import style0 from "./websiteConfig.vue?vue&type=style&index=0&id=3596034c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3596034c",
  null
  
)

export default component.exports